import React from "react";

export default function CloseIcon({ size, fill }) {
  return (
    <svg
      width={size ? size : "29"}
      height={size ? size : "29"}
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14.5" cy="14.5" r="14" fill="white" stroke="#575757" />
      <path
        d="M16.6523 15.25L20.4492 19.0469C20.6602 19.2578 20.6602 19.6445 20.4492 19.8555L19.5703 20.7344C19.3594 20.9453 18.9727 20.9453 18.7617 20.7344L15 16.9375L11.2031 20.7344C10.9922 20.9453 10.6055 20.9453 10.3945 20.7344L9.51562 19.8555C9.30469 19.6445 9.30469 19.2578 9.51562 19.0469L13.3125 15.25L9.51562 11.4883C9.30469 11.2773 9.30469 10.8906 9.51562 10.6797L10.3945 9.80078C10.6055 9.58984 10.9922 9.58984 11.2031 9.80078L15 13.5977L18.7617 9.80078C18.9727 9.58984 19.3594 9.58984 19.5703 9.80078L20.4492 10.6797C20.6602 10.8906 20.6602 11.2773 20.4492 11.4883L16.6523 15.25Z"
        fill={fill ? fill : "#575757"}
      />
    </svg>
  );
}
